export class LowBatteryAlertSetting{
  companyId?: string;
  mailAddresses?: string[];
  threshold?: number;

  constructor(params?: Partial<LowBatteryAlertSetting>) {
    Object.assign(this, params);
  }
}